import { render, staticRenderFns } from "./ServicesTwo.vue?vue&type=template&id=683d4dac&scoped=true&"
import script from "./ServicesTwo.vue?vue&type=script&lang=js&"
export * from "./ServicesTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683d4dac",
  null
  
)

export default component.exports